// Sidebar entries owned by the Survey module. The shell places them: see
// src/app/nav.tsx and src/modules/README.md.
import { surveyPaths } from './paths'

// The sidebar fields Survey's entry uses. Structurally the app's SidebarType
// (src/types/shared): src/app/nav.tsx places these entries, so a drift between
// the two fails typecheck there.
interface SurveyNavItem {
    title: string
    path: string
}

export const surveyNav = {
    list: {
        title: 'surveys:sidebar_title',
        path: surveyPaths.surveys,
    },
} satisfies Record<string, SurveyNavItem>
